/*
 * Landing-page sections runtime. Keeps --lp-scale on :root in step with the
 * viewport so every stacked section canvas scales together. The inline script
 * in snippets/lp-runtime.liquid sets it pre-paint; this keeps it current and
 * re-applies after any responsive-image swap.
 */
(function () {
  'use strict';
  // Rendered once per section, so guard against running 11 times on a full page.
  if (window.__lpSectionsInit) return;
  window.__lpSectionsInit = true;

  function setScale() {
    var w = document.documentElement.clientWidth;
    var s = w <= 600 ? w / 320 : Math.min(w / 1200, 1);
    document.documentElement.style.setProperty('--lp-scale', s);
    applyImages();
  }

  var DENS = ['1x', '2x', '3x'];
  function applyImages() {
    var mobile = document.documentElement.clientWidth <= 600;
    var imgs = document.querySelectorAll('.lp-section img[data-src-desktop-1x], .lp-section img[data-src-mobile-1x]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i], set = [], fallback = null;
      for (var d = 0; d < DENS.length; d++) {
        var u = img.getAttribute('data-src-' + (mobile ? 'mobile' : 'desktop') + '-' + DENS[d]) ||
                img.getAttribute('data-src-desktop-' + DENS[d]);
        if (!u) continue;
        if (!fallback) fallback = u;
        set.push(u + ' ' + DENS[d]);
      }
      if (!fallback) continue;
      if (set.length > 1) img.srcset = set.join(', ');
      img.src = fallback;
    }
  }

  var obs = null;
  function observeAnimations() {
    if (typeof IntersectionObserver !== 'function') return;
    var els = document.querySelectorAll('.lp-section [class*="ub-ani"]');
    if (!els.length) return;
    if (!obs) {
      obs = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { e.target.classList.toggle('ub-ani-play', e.isIntersecting); });
      }, { threshold: 0.5 });
    }
    // observe() ignores elements it already watches, so re-running after a section load is safe
    for (var i = 0; i < els.length; i++) obs.observe(els[i]);
  }

  setScale();
  observeAnimations();
  var raf;
  addEventListener('resize', function () { if (raf) cancelAnimationFrame(raf); raf = requestAnimationFrame(setScale); });
  // Theme editor: re-run when a section is added/reordered
  document.addEventListener('shopify:section:load', function () { setScale(); observeAnimations(); });
})();
